// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"352":"328d7725","453":"33af140f"}[chunkId] + ".chunk.js";
};